import {React} from 'react';
import './App.css';
import CountdownPage from './CountdownPage';

function App() {
    
  return (
    <div className="App">
      <h2 className='header'>Count Down Timer</h2>
      <p className='rider'>Looking forward to that big event? <br/>
      Set a countdown to see how long you have till that day!</p>
     
      <CountdownPage />
      <footer >&copy; 2022 Silver_Codes. All Rights Reserved</footer>
    </div>
  );
}

export default App;
